import React, { useEffect, useState } from "react";
import axios from "axios";

import Canvas from "./Canvas";
import Abacus from "./Abacus";

import { Lib, LibPage } from "./BoardStyled";
import { Nav, Container } from "../App/AppStyled";

import { FaAngleRight, FaUserAlt } from "react-icons/fa";

const Board = ({ data, hash }) => {
  const room = data.id;
  const name = data.name;

  const [modules, setModules] = useState([]);
  const [activeBook, setActiveBook] = useState(null);
  const [page, setPage] = useState(null);

  const handleActiveBook = (name) => {
    setActiveBook(activeBook !== name ? name : null);
  };

  useEffect(() => {
    const fetch = () => {
      const urlParams = new URLSearchParams(window.location.search);

      axios
        .get(process.env.REACT_APP_API_URL + "/db.json")
        .then(({ data }) => data)
        .then(
          (data) => data.find((d) => d.lang === urlParams.get("lang")).types
        )
        .then(
          (data) => data.find((d) => d.type === urlParams.get("type")).books
        )
        .then((modules) => {
          axios
            .get(
              process.env.REACT_APP_SYSTEM_URL +
                "/json/child-data/" +
                room +
                "/" +
                hash
            )
            .then(({ data }) => {
              let tmpModules = [];

              modules.forEach((module) => {
                if (
                  data.additionals.indexOf(
                    urlParams.get("lang") + "_" + urlParams.get("type") + "_" + module.name
                  ) !== -1
                ) {
                  tmpModules.push(module);
                }
              });

              if (
                data.additionals.indexOf(
                  urlParams.get("lang") + "_" + urlParams.get("type")
                ) === -1
              ) {
                tmpModules = [];
              }

              setModules(tmpModules);
            });
        });
    };
    fetch();
    setPage(null);
  }, [room, hash]);

  return (
    <>
      {modules && !page && (
        <>
          <Nav>
            <img
              src="https://system.geniuspolska.com/img/logo.png"
              alt="logo"
              style={{ display: "block", height: "50px", margin: "0 auto" }}
            />
          </Nav>
          <Container bg="transparent">
            <h3 style={{ marginTop: 0, textAlign: "center" }}>
              <FaUserAlt /> {name}
            </h3>
            {modules.map((module) => (
              <Lib key={module.name}>
                <h4 onClick={() => handleActiveBook(module.name)}>
                  <FaAngleRight /> {module.name}
                </h4>
                <div
                  className="grid"
                  style={{
                    display: activeBook === module.name ? "grid" : "none",
                  }}
                >
                  {module.pages.map((page, i) => (
                    <LibPage
                      key={page.name}
                      onClick={() =>
                        setPage({
                          module: module.name,
                          page: page.name,
                          image: process.env.REACT_APP_API_URL + page.url,
                        })
                      }
                    >
                      <img
                        src={process.env.REACT_APP_API_URL + page.thumb}
                        alt={page.name}
                      />
                      <h3>{i + 1}</h3>
                    </LibPage>
                  ))}
                </div>
              </Lib>
            ))}
            {!modules.length ? <p style={{ textAlign: "center" }}>-</p> : null}
          </Container>
        </>
      )}

      {page && <Abacus room={room} data={page} />}
      {page && <Canvas room={room} data={page} back={() => setPage(null)} />}
    </>
  );
};

export default Board;
